import { BaseDataLayerKey, formatCount } from "../layers";

/** Return the upload slot id used for uploads started from a base data row. */
export const getBaseDataUploadId = (key: BaseDataLayerKey): string => `base-data-${key}`;

/** Return the label of the button that uploads the given number of layers. */
export const getUploadButtonLabel = (layerCount: number): string => (layerCount > 1 ? `Upload ${layerCount} layers` : "Upload");

/** Return the result line of an upload into one planner layer, given its feature nouns, e.g. "73 addresses added". */
export const getUploadResultMessage = (units: readonly [string, string], count: number | null | undefined): string => {
  if (count === null || count === undefined) return "Added";
  return `${formatCount(count, units)} added`;
};
